export default {
    comingSoonTips: '申请供股功能即将上线，敬请期待。',
    HKStockMarket: '港股市场',
    historyList: '历史记录',
    doNotHoldStocks: '您未持有待供股股票',
    applyStocksTips: '您持有的股票待供股，请在供股截止日前选择是否供股；逾期未选择视为放弃供股。',
    requested: '已申请',
    rightIssueCode: '供股权代码',
    stockPrice: '供股价',
    availableStockNumbers: '可供股数量',
    availableStockNumbersTips: '可供股数量=派发的供股权数量+买入的供股权数量-卖出/冻结的供股权数量',
    tenderOfferAvailableQuantity: '可用数量',
    stock: '股',
    stockDeadline: '供股选择截止时间：',
    warmTips: '温馨提示：',
    warmTips1: '认购金额将在发起申请后实时冻结，并于供股选择截止后扣款。撤销仅在扣款前支持操作（具体时间以页面提示的为准）。',
    warmTips2: '手续费包括交易所收费（每手0.8港元），复星国际证券收费（50.00港元），不足一手以一手计算。',
    warmTips3: '因需要处理派发手续，系统将于正股派发日后的1-2个工作日将正股存入您的账户，具体时间以实际到账为准。',
    warmTips4:
        '香港中央結算（代理人）有限公司將會按照中央結算系統參與者各自申請認購之額外供股股份數目將其接獲之額外供股股份按比例分配予有關中央結算系統參與者，或根據中央結算系統運作程序規則第8.10.4(ix)條規定之分配基準按照香港中央結算（代理人）有限公司認為公平恰當之其他方式分配。',
    listed: '上市',
    lastTrade: '最后交易',
    rightsIssueDeadline: '供股截止',
    stockDistribution: '正股派送',
    rightsIssueInfo: '供股信息',
    stockName: '股票名称',
    additionalRightsIssues: '额外供股',
    opening: '开放',
    notOpen: '不开放',
    rightsIssueTransactions: '供股权交易',
    Tradable: '可交易',
    notTradable: '不可交易',
    equityInfo: '权益信息',
    rightsIssuePurchased: '买入供股权数量',
    rightsIssueSold: '卖出/冻结供股权数量',
    rightsIssueSoldTips: '当供股权可交易时，已挂卖出单或者已卖出的供股权数量',
    additionalSharesAvailable: '额外可供股数量',
    additionalSharesAvailableTips: '当开放额外供股时，最大可供股数量为“数量不限”；否则数量为0；',
    unlimitedQuantity: '数量不限',
    chooseIssueShares: '选择是否供股',
    applicationsNumber: '申请数量(股)',
    applicationsNumber1: '申请数量',
    applicationsNumber2: '申请供股数量',
    upperLimit: '上限',
    additionalApplicationsNumber: '额外申请数量(股)',
    additionalApplicationsNumber1: '额外申请数量',
    additionalApplicationsNumber2: '额外申请供股数量',
    availableCash: '可用现金',
    estimatedFreezeAmount: '预计冻结金额 (含手续费)',
    rightsIssueOptions: '供股选择',
    rightsIssueApplications: '申请中供股数量',
    rightsIssueStatus: '供股状态',
    rightsIssueWaiver: '放弃供股',
    rightsIssueApply: '申请供股',
    rightsIssueVoluntaryWaiver: '自动放弃供股',
    applicationCanceled: '撤销申请',
    applyImmediately: '立即申请',
    applicationTips1: '请输入申请数量',
    applicationTips2: '您申请的数量超过上限！',
    applicationTips3: '您的可用现金不足！',
    applicationTips4: '您的可用股份数量不足！',
    confirmApplicationTips: '确认是否撤销申请？',
    confirm: '确定',
    undoSucceeded: '撤销成功',
    applicationConfirm: '申请确认',
    applicationConfirmTips: '确认是否放弃供股？',
    applicationSuccessful: '申请成功',
    understood: '已了解',
    wrongPassword: '密码错误',
    processing: '处理中',
    applicationAmount: '申请金额（含手续费）',
    actualDistributedNumber: '实际派送股数',
    stockDeliveryTime: '正股派送时间',
    requestFailed: '请求失败',
    noMore: '没有更多了',
    noStockTips: '您暂无申请供股记录',
    loginFailedTips: '登录失效，请重新登录',
    stystemBusyTips: '网络连接超时，请稍后重试。如有疑问，请联系客服。',
    optionsBonusPageTitle: '交易期权赢奖金活动',
    eventRule: '活动规则',
    goTrade: '去交易',
    optionsBonusShareDesc: '限时期权交易活动，最高可领100,000HKD奖励。',
    tenderOffer: '要约收购',
    offerType: '要约类型',
    unconditionalOffer: '无条件要约',
    tenderOfferPrice: '要约价格',
    tenderOfferDeadline: '要约收购截止时间：',
    pendingApply: '待申请',
    noTenderOfferStocks: '您未持有待要约收购股票',
    tenderOfferDetail: '要约收购详情',
    startApplication: '开始申报',
    applicationDeadline: '申报截止',
    lastTradingDay: '最后交易日',
    cashArrival: '现金到账',
    pleaseFollowCashFlow: '请关注资金流水',
    conditionalOffer: '有条件要约',
    chooseTenderOffer: '选择是否接受要约',
    acceptTenderOffer: '接受要约',
    waiveTenderOffer: '放弃要约',
    transactionAmountEstimate: '交易金额（按全部成交预估）',
    conditionalOfferDisclaimer: '若为有条件要约，要约人不保证全部接受',
    handlingFee: '手续费（按全部成交预估）',
    feeStandard: '收费标准',
    disclaimer: '免责声明',
    tenderOfferDetailWarmTips1: '接受要约的股份将在提交申请后实时冻结，并于要约收购截止后扣除。',
    tenderOfferDetailWarmTips2: '如需撤销，您可在要约收购截止时间之前申请。',
    tenderOfferDetailWarmTips3: '手续费：从到账资金中扣除，按交易金额的0.25%（最低HKD）收取，另外交易所按相关标准收取，详见',
    tenderOfferDetailWarmTips4: '请阅读',
    tenderOfferWaiveConfirm: '确认是否放弃要约？',
    tenderOfferSelection: '要约选择',
    tenderOfferStatusLabel: '要约状态',
    tenderOfferStatusWaived: '已放弃',
    tenderOfferType: '要约收购类型',
    noTenderOfferHistoryTips: '您暂无要约收购记录',
    tenderOfferHistoryStatusAccepted: '已接受',
    tenderOfferHistoryStatusWaived: '已放弃',
    tenderOfferHistoryStatusPending: '未处理',
    tenderOfferHistoryStatusDeductSuccess: '扣货成功',
    tenderOfferHistoryStatusDeductFailed: '扣货失败',
    tenderOfferHistoryStatusDeducting: '扣货中',
    tenderOfferResultFinish: '完成',
    estimated: '预计',
}
